'use strict';

var $;
var tag;

var index = {
  name: 'fixed-header',

  props: {
    threshold: {
      type: Number,
      default: 0,
      required: false
    }
  },

  mounted: function mounted () {
    $ = function (e) { return document.querySelector(e); };
    tag = ( !window.chrome && 'WebkitAppearance' in document.documentElement.style ) ? 'body' : 'html';
    this.main();
  },

  methods: {
    main: function main () {
      var this$1 = this;

      this.check = function () {
        this$1.$emit('update:fixed', $(tag).scrollTop > this$1.threshold);
      };
      window.addEventListener('scroll', this.check);
    }
  },

  beforeDestory: function beforeDestory () {
    window.removeEventListener('scroll', this.check);
  },

  render: function render(h) {
    var children = this.$slots.default;
    return children[0]
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vue-fixed-header/dist/vue-fixed-header.common.js
// module id = 362
// module chunks = 5